class TabSlideshow {
    constructor(tabSectionSelector, { autoplay = true, duration = 5 } = {}) {
      this.tabSection = document.querySelector(tabSectionSelector);
      this.tabs = this.tabSection.querySelectorAll('.tab-selector');
      this.slides = this.tabSection.querySelectorAll('.tab-content');
      this.currentTabId = null;
      this.duration = duration * 1000; // Convert seconds to milliseconds
      this.interval = null;
			this.autoplay = this.tabSection.getAttribute('data-autoplay') === 'true';
			this.showNavigationButtons = this.tabSection.getAttribute('data-show-nav');

      this.init();
    }

    init() {
      // Attach click events to tabs
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const tabId = tab.getAttribute('data-tab-id');
          this.switchToTab(tabId);
        });
      });

      // Initialize the first active tab
      const activeTab = this.tabSection.querySelector('.tab-selector .active');
      if (activeTab) {
        this.currentTabId = activeTab.closest('.tab-selector').getAttribute('data-tab-id');
        this.switchToTab(this.currentTabId);
      }

      // Set up autoplay if enabled
      if (this.autoplay) {
        this.startAutoplay();

        // Pause autoplay on mouse enter and resume on mouse leave
        this.tabSection.addEventListener('mouseenter', () => this.stopAutoplay());
        this.tabSection.addEventListener('mouseleave', () => this.startAutoplay());
      }

			// Set up navigation buttons if enabled
			if (this.showNavigationButtons) {
				const prevButton = this.tabSection.querySelector('.prev-button');
				const nextButton = this.tabSection.querySelector('.next-button');

				if (prevButton) {
					prevButton.addEventListener('click', () => { this.prevSlide(); });
				}

				if (nextButton) {
					nextButton.addEventListener('click', () => { this.nextSlide(); });
				}
			}
    }

    startAutoplay() {
      this.stopAutoplay(); // Clear any existing interval
      this.interval = setInterval(() => {
        this.nextSlide();
      }, this.duration);
    }

    stopAutoplay() {
      clearInterval(this.interval);
    }

		prevSlide() {
      const currentIndex = Array.from(this.slides).findIndex(
        (slide) => slide.getAttribute('data-tab') === this.currentTabId
      );
      let prevIndex = (currentIndex - 1) % this.slides.length;
			if (prevIndex < 0) {
				prevIndex = this.slides.length - 1;
			}
      const prevTabId = this.slides[prevIndex].getAttribute('data-tab');
      this.switchToTab(prevTabId);
    }

    nextSlide() {
      const currentIndex = Array.from(this.slides).findIndex(
        (slide) => slide.getAttribute('data-tab') === this.currentTabId
      );
      const nextIndex = (currentIndex + 1) % this.slides.length;
      const nextTabId = this.slides[nextIndex].getAttribute('data-tab');
      this.switchToTab(nextTabId);
    }

    switchToTab(tabId) {
      // Deactivate all tabs and slides
      this.tabs.forEach((tab) => {
        const button = tab.querySelector('button');
        button.classList.remove('active');
        button.classList.add('inactive');
      });

      this.slides.forEach((slide) => {
		if (slide.classList.contains('opacity-100')) {
			slide.classList.add('fade-out');
		}
		if (slide.classList.contains('fade-in')) {
			slide.classList.add('fade-out');
		}
		slide.classList.remove('fade-in');
      });

      // Activate the selected tab and slide
      const selectedTab = this.tabSection.querySelector(`.tab-selector[data-tab-id="${tabId}"]`);
      const selectedSlide = this.tabSection.querySelector(`.tab-content[data-tab="${tabId}"]`);

      if (selectedTab && selectedSlide) {
        const button = selectedTab.querySelector('button');
        button.classList.add('active');
        button.classList.remove('inactive');

		selectedSlide.classList.add('fade-in');
		selectedSlide.classList.remove('fade-out');
		selectedSlide.classList.remove('invisible');
      }

      // Update the current tab ID
      this.currentTabId = tabId;
    }
  }

  // Initialize the TabSlideshow
  new TabSlideshow('.tab-section');
